import { render, staticRenderFns } from "./BackofficeEnviaCodigoPrestadorSolicitante.vue?vue&type=template&id=246e9c1a"
import script from "./BackofficeEnviaCodigoPrestadorSolicitante.vue?vue&type=script&lang=ts"
export * from "./BackofficeEnviaCodigoPrestadorSolicitante.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports